import React from 'react';

class AirconIcon extends React.Component {
  state = {
    type: this.props.type
  };
  render() {
    return (
      <React.Fragment>
        {this.state.type === 'down' ? (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M38 31V29H22V31H38Z" fill="#8A8B8D" />
          </svg>
        ) : (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29 29V22H31V29H38V31H31V38H29V31H22V29H29Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
      </React.Fragment>
    );
  }
}

export default AirconIcon;
